import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';
import { catchError, tap } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { ICompanyData } from '../../@theme/layouts';

@Injectable()
export class CompanyDataService {
  private companyData$ = new BehaviorSubject<ICompanyData | null>(null);
  private isLoaded = false;

  constructor(private httpClient: HttpClient) {}

  /**
   * Get company data from cache or load from API if not cached
   */
  getCompanyData(): Observable<ICompanyData> {
    if (this.isLoaded && this.companyData$.value) {
      return new Observable((observer) => {
        // tslint:disable-next-line:no-non-null-assertion
        observer.next(this.companyData$.value!);
        observer.complete();
      });
    }

    return this.loadCompanyData();
  }

  /**
   * Force reload company data from API
   */
  reloadCompanyData(): Observable<ICompanyData> {
    this.isLoaded = false;
    return this.loadCompanyData();
  }

  /**
   * Get cached company data synchronously (if available)
   */
  getCachedCompanyData(): ICompanyData | null {
    return this.companyData$.value;
  }

  /**
   * Load company data from API and cache it
   */
  private loadCompanyData(): Observable<ICompanyData> {
    return this.httpClient.get<ICompanyData>(environment.service_company_data)
      .pipe(
        tap((data) => {
          this.companyData$.next(data);
          this.isLoaded = true;
        }),
        catchError((error) => {
          console.error('Failed to load company data:', error);
          return Observable.throw(error);
        }),
      );
  }
}



// WEBPACK FOOTER //
// ./src/app/@core/services/company-data.service.ts